import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() currentStep!: number;
  @Input() steps!: number;
  @Input() showInfo!: boolean;
  @Input() isSummary: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
